/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAppointmentNoteStamps200ResponseInner
 */
export interface GetAppointmentNoteStamps200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentNoteStamps200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentNoteStamps200ResponseInner
     */
    name: string;
}

/**
 * Check if a given object implements the GetAppointmentNoteStamps200ResponseInner interface.
 */
export function instanceOfGetAppointmentNoteStamps200ResponseInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function GetAppointmentNoteStamps200ResponseInnerFromJSON(json: any): GetAppointmentNoteStamps200ResponseInner {
    return GetAppointmentNoteStamps200ResponseInnerFromJSONTyped(json, false);
}

export function GetAppointmentNoteStamps200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentNoteStamps200ResponseInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function GetAppointmentNoteStamps200ResponseInnerToJSON(value?: GetAppointmentNoteStamps200ResponseInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

